exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile-21kB8{background:#fff;border:1px solid #d9dfea;padding:40px 30px 20px 30px;margin-bottom:20px;font-size:16px;overflow-wrap:break-word}.body-3y06B{line-height:20px}.body-3y06B *{font-size:16px !important}.body-3y06B h1{color:#39395b;opacity:.4;font-weight:400 !important}.btnGroupHover-1DVjk{margin:20px 0;height:25px}.btnGroupHover-1DVjk>*{opacity:0}.btnGroupHover_show-3yrXE>*{opacity:1}", ""]);

// exports
exports.locals = {
	"tile": "tile-21kB8",
	"body": "body-3y06B",
	"btnGroupHover": "btnGroupHover-1DVjk",
	"btnGroupHover_show": "btnGroupHover_show-3yrXE"
};